import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, of } from 'rxjs';
import { environment } from '../environments/environment';
import { Userlist } from '../models/userlist';
import { ordersResponse } from '../models/orders';
import { LoggedInUser } from '../models/loggedinuser';
import { Order } from '../models/order'
import { ERPCustomers, ERPProducts } from '../models/erpcustomers';
import { Checklist, createResponse } from '../models/checklist';
import { instructionList } from '../models/instructionlist';
import { calendarEvent } from '../models/calendarevent';
import { calendarEventList } from '../models/calendareventlist';
import { customizing } from '../models/customizing';
import { categories } from '../models/categories';
import { activeUsers } from '../models/activeusers';
import { smartMonitorLogin } from '../models/smartmonitorlogin';
import { notes, printer } from '../models/notes';
import { ConfigService } from './config.service';
import { delay, switchMap, tap } from 'rxjs/operators';
import { io, Socket } from 'socket.io-client';
import version_config from '../../src/assets/version.json';
import { IDBStorage } from './idb-storage';
@Injectable({
  providedIn: 'root',
})
export class ApiService {
   // url = this.config.getConfig().baseUrl;
  url = '';
  private socket: Socket | null = null;
  private socketReady$ = new ReplaySubject<Socket>(1); // Emits once socket is ready
  private withoutintercept: HttpClient;
  public data: any;
  config: any = null;
  idb = new IDBStorage();
  constructor(private http: HttpClient, private handler: HttpBackend, private configService: ConfigService) {
    this.withoutintercept = new HttpClient(handler);
    this.configService.getConfigAsync()
      .pipe(
        tap((config: any) => {
          this.config = config;
          this.url = config.baseUrl;
          console.log('Config loaded:', this.config);
          // Initialize socket after config is loaded
          this.initSocket(this.config);
          // this.socket = io(this.config.socketUrl, { path: this.config.socketFolder });
          // this.socket.on('connect', () => {
          //   console.log('Connected to socket');
          // });
        })
      )
      .subscribe();
    this.data = version_config;
    console.log(this.data)
  }

   private initSocket(config: any): void {
    if (this.socket) {
      this.socket.disconnect(); // Prevent duplicate connections
    }

    this.socket = io(config.socketUrl, {
      path: config.socketFolder,
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      // pingTimeout: 10000,
      // pingInterval: 5000,
    });

    this.socket.on('connect', () => {
      console.log('Socket connected:', this.socket?.id);
    });

    this.socket.on('disconnect', (reason) => {
      console.warn('Socket disconnected:', reason);
      if (reason === 'io server disconnect') {
        this.socket?.connect(); // Manual reconnect required for server-initiated disconnects
      }
    });

    this.socket.on('reconnect', (attempt) => {
      console.log(`Reconnected after ${attempt} attempt(s)`);
    });

    // Signal that socket is ready for consumers
    this.socketReady$.next(this.socket);
  }

  // Listen to a specific named event
  listenToEvent(eventName: string): Observable<any> {
    return this.socketReady$.pipe(
      switchMap(socket =>
        new Observable(observer => {
          const handler = (data: any) => observer.next(data);
          socket.on(eventName, handler);
          // Cleanup when component unsubscribes
          return () => socket.off(eventName, handler);
        })
      )
    );
  }

  // Listen to ALL events (your onAny use case)
  listenToAnyEvent(): Observable<any> {
    return this.socketReady$.pipe(
      switchMap(socket =>
        new Observable(observer => {
          const handler = (event: string, message: any) => observer.next({ event, message });
          socket.onAny(handler);
          return () => socket.offAny(handler);
        })
      )
    );
  }

  SocketERPOrdersResync(): Observable<any> {
    return this.http.post(`${this.url}/Socket-ERPOrdersResync`, {})
  }

  disconnect(): void {
    this.socket?.disconnect();
  }

  getERPOrdersResync(customerID: string | null): Observable<any> {
    return new Observable(observer => {
      if (!customerID || customerID === '') {
        observer.error('Customer ID is null');
        observer.complete();
        return;
      }
      this.socket?.on(`event_broadcast_customer_${customerID}`, (data: any) => {
        observer.next(data);
      });
    });
  }
  // login
  doLogin(login: any): Observable<LoggedInUser> {
    return this.http.post<LoggedInUser>(`${this.url}/login`, login);
  }

  LoginMonitor(login: any): Observable<smartMonitorLogin> {
    return this.http.post<smartMonitorLogin>(`${this.url}/login-monitor`, login);
  }

  getcustomers(): Observable<ERPCustomers> {
    return this.http.get<ERPCustomers>(`${this.url}/ERPCustomers`);
  }

  getuserlist(id: any): Observable<activeUsers> {
    let version = this.data.VERSION
    return this.http.get<activeUsers>(`${this.url}/UsersLoggedIn?version=${version}`);
  }

  getAvailableUsersList(userids: any, id: any): Observable<Userlist> {
    return this.http.get<Userlist>(`${this.url}/Users` + '?' + "userids=" + userids + "&workstationID=" + id);
  }

  getorder(userid: any, workstationID: any, mode?: any): Observable<ordersResponse[]> {
    return this.http.get<ordersResponse[]>(`${this.url}/Events` + '?' + "fkWorkstationID=" + workstationID + "&" + "userID=" + userid + "&" + "eventType=" + mode);
  }


  addorder(data: any): Observable<Order> {
    return this.http.post<Order>(`${this.url}/Order`, data);
  }

  stopevent(data: any) {
    return this.http.put(`${this.url}/Order`, data);
  }

  getcategories(userid: any, level: any = null): Observable<categories> {
    return this.http.get<categories>(`${this.url}/Categories` + '?' + "customerID=" + userid + (level ? `&level=${level}`:''));
  }

  addformfield(data: any) {
    return this.http.post(`${this.url}/FormFields`, data);
  }

  createalert(data: any) {
    return this.http.post(`${this.url}/Alert`, data);
  }

  adduser(data: any) {
    return this.http.post(`${this.url}/UsersLoggedIn`, data)
  }

  deleteuser(data: any) {
    return this.http.put(`${this.url}/UsersLoggedIn`, data)
  }

  geterp(): Observable<any> {
    return this.http.get(`${this.url}/ERPOrders`);
  }

  getattachment(data: any, workstationid: any) {
    let orderId = data.orderID ? data.orderID : '';
    let orderkey = data.mapping_field ? data.mapping_field : '';
    return this.http.get(`${this.url}/Attachments` + '?' + "orderID=" + orderId + "&" + "orderkey=" + orderkey + "&" + "fkWorkstationID=" + workstationid);
  }

  getnotes(orderID: any): Observable<notes[]> {
    return this.http.get<notes[]>(`${this.url}/Notes` + '?' + "orderID=" + orderID);
  }

  getgreenactivities(): Observable<customizing> {
    return this.http.get<customizing>(`${this.url}/Customizing`);
  }

  changeLanguage(data: any): Observable<createResponse> {
    return this.http.put<createResponse>(`${this.url}/Users`, data);
  }

  getCalendar(userID: any): Observable<calendarEventList> {
    return this.http.get<calendarEventList>(`${this.url}/Calendar` + '?userID=' + userID + "&numberOfDaysHistory=");
  }

  create_event(data: any): Observable<calendarEvent> {
    return this.http.post<calendarEvent>(`${this.url}/Calendar`, data);
  }

  delete_event(data: any): Observable<createResponse> {
    return this.http.put<createResponse>(`${this.url}/Calendar`, data);
  }

  SetTimerForYellow(data: any) {
    return this.http.post(`${this.url}/TimerForYellowEvent`, data);
  }

  ForgotPassword(data: any): Observable<createResponse> {
    return this.http.post<createResponse>(`${this.url}/password-forget`, data);
  }

  syncingOrder(): Observable<ERPCustomers> {
    return this.http.get<ERPCustomers>(`${this.url}/ERPSync`);
  }

  getERPProductsByCustomerId(customerInfo: { customer: any }): Observable<ERPProducts> {
    return this.http.post<ERPProducts>(`${this.url}/ERPProducts`, customerInfo);
  }

  getChecklist(userID: string, flag: string, orderID: string, orderkey: string): Observable<Checklist> {
    return this.http.get<Checklist>(`${this.url}/Checklist` + '?userID=' + userID + '&processStep=' + flag + '&orderID=' + orderID + '&orderkey=' + orderkey);
  }

  getInstructions(orderID: string, orderkey: string): Observable<instructionList> {
    return this.http.get<instructionList>(`${this.url}/Instructions` + '?orderID=' + orderID + '&orderkey=' + orderkey);
  }

  postInstructions(data: any): Observable<any> {
    return this.http.post(`${this.url}/Instructions`, data);
  }
  createERPOorder(info: any) {
    return this.http.post(`${this.url}/ERPOrder`, info);
  }

  createCheckList(info: any): Observable<createResponse> {
    return this.http.post<createResponse>(`${this.url}/Checklist`, info);
  }

  deleteERPOorder(info: any) {
    return this.http.put(`${this.url}/ERPOrder`, info);
  }

  getPDFFile(info: any) {
    return this.http.post(`${this.url}/IJBweeklyPDF`, info);
  }

  addQuantity(info: any) {
    return this.http.post(`${this.url}/Print`, info);
  }
  aaddQuantity(orderID: string, orderkey: string, userID: string, workstationID: string): Observable<any> {
    return this.http.get(`${this.url}/Print` + "?orderID=" + orderID + "&orderkey=" + orderkey + "&userID=" + userID);
  }

  localhostPost(info: any) {
    return this.http.post(`http://localhost:8000`, info);
  }

  updateERProductsQTY(info: any) {
    return this.http.put(`${this.url}/ERPProducts`, info);
  }

  updateWorkLocation(info: any) {
    return this.http.post(`${this.url}/CalendarWorkLocation`, info);
  }

  authentication(info: any) {
    return this.http.post(`${this.url}/2FA`, info);
  }

  validateAutoLoginToken(info: any): Observable<LoggedInUser> {
    return this.http.post<LoggedInUser>(`${this.url}/validateAutoLoginToken`, info);
  }

  getMessages(payload: any): Observable<any> {
    return this.http.post(`${this.url}/getMessages`, payload);
  }

  public async errorLog(data: any) {
    this.withoutintercept.post(`${this.url}/errorLog`, data).subscribe((res: any) => {
    }, (err) => {
      console.log(err)
    });
  }
  public validateprojectnumber(data: any): Observable<any> {
    return this.http.post(`${this.url}/IJB-validate-projectnumber`, data)
  }

  public getFileBlob(url: string): Observable<any> {
    return this.http.get(url, { responseType: 'blob' });
  }

  public getAttachments(base64: string): Observable<any> {
    let obj = {
      data_pdf: base64
    }
    return this.http.put(`${this.url}/Attachments`, obj);
  }
  public getPrintersForWorkstation(): Observable<any> {
    return this.http.get(`${this.url}/getPrintersForWorkstation`)
  }
  public setPrinterForWorkstation(data: printer): Observable<any> {
    return this.http.post(`${this.url}/setPrinterForWorkstation`, data)
  }

  getSuggestions(wsId: any, limit: any, orderId?: any): Observable<any> {
    return this.http.get(`${this.url}/ImprovementSuggestion?workstationID=${wsId}&limit=${limit}${orderId ? `&orderID=${orderId}`:''}`);
  }

  getSuggestionById(id: any): Observable<any>{
    return this.http.get(`${this.url}/ImprovementSuggestion?id=${id}`);
  }

  createSuggestion(data: any): Observable<any>{
    return this.http.post(`${this.url}/ImprovementSuggestion`, data);
  }
  
  addSuggestionFields(data: any): Observable<any>{
    return this.http.post(`${this.url}/ImprovementSuggestion/fields`, data);
  }

  /**
   * Temporary photo fetch until the suggestion photo API exists.
   * The wizard calls this instead of rendering placeholder images.
   */
  getSuggestionPhotos(suggestionId: number | null): Observable<string[]> {
    if (suggestionId == null) {
      return of([]);
    }
    return of([]).pipe(delay(400));
  }
}

